import React, { useEffect, useState } from "react";
import "./roomCatalogue.css"; // Update the path if needed
import { REACT_APP_URL } from "../../../config";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import youtubeImg from "../../../assets/Image/youtube.png"

import ProductMagnification from "../../../components/productMagnification/ProductMagnification";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "97%",
  height: "95%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const RoomSliderCusProd = ({ productImages, type = "" }) => {
  // console.log("productImages", productImages);
  const [selectedImage, setSelectedImage] = useState({ image: "", index: 0 });
  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (productImages?.length > 0) {
      setSelectedImage({ image: productImages[0], index: 0 });
    }
    // console.log(selectedImage)
  }, [productImages]);

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="fingerprint"
              color="success"
              sx={{ float: "right", top: 0, right: 0, position: "absolute" }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
            <ProductMagnification
              images={productImages}
              activeIndex={activeIndex}
            />
          </Box>
        </Fade>
      </Modal>

      <div className="col-lg-2 SliderProductImages">
        {/* {productImages &&
          productImages.map((image, index) => (

            <img
              key={index}
              className="SliderProductImages1"
              src={`${REACT_APP_URL}/images/product/${image}`}
              alt={image}
              onClick={() => setSelectedImage({ image, index })}
            />
          ))} */}
        {productImages && productImages.map((media, index) => {
          const isVideo = media?.includes("youtube.com");
          let thumbUrl;
          if (isVideo) {
            let videoId = media.match(/(?:\/embed\/|v=)([^&?/]+)/)[1];
            thumbUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          }

          return isVideo ? (
            <div
              key={index}
              style={{
                position: "relative",
                display: "inline-block",
                cursor: "pointer",
                height: "auto",
                margin: "0 5px",
                minWidth: "20%",
                width: "100%",
              }}
              onClick={() => setSelectedImage({ image: media, index })}
            >
              <img
                className="SliderProductImages1"
                src={thumbUrl}
                alt={`media-${index}`}
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
              />

              {/* YouTube play icon overlay */}
              <img
                src={youtubeImg}
                alt="YouTube"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "40px",
                  height: "40px",
                  transform: "translate(-50%, -50%)",
                  opacity: 0.8,
                  pointerEvents: "none",
                }}
              />
            </div>

          ) : (
            <img
              key={index}
              className="SliderProductImages1"
              src={`${REACT_APP_URL}/images/product/${media}`}
              alt={`media-${index}`}
              onClick={() => setSelectedImage({ image: media, index })}
            />
          );
        })}
      </div>
      <div className="col-lg-10 SliderProductImages3">
        {
        
          selectedImage?.image && selectedImage?.image.includes("youtube.com") ?
            <iframe
              width="800px"
              height="560px"
              src={`${selectedImage?.image}&autoplay=1&mute=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: "relative",
                top: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            ></iframe>
            :
            <img
              className="SliderProductImages2"
              src={`${REACT_APP_URL}/images/product/${selectedImage?.image}`}
              alt={selectedImage}
              onClick={() => {
                setActiveIndex(selectedImage?.index);
                handleOpen();
              }}
            />}
      </div>
    </>
  );
};

export default RoomSliderCusProd;
